import { TLoginApiResponse, TLoginUser } from '@/types/users';
import ApiService from './ApiService';

class LoginRepository extends ApiService {
  constructor() {
    super('/auth');
  }

  async login(loginData: TLoginUser): Promise<TLoginApiResponse> {
    return await this.post<TLoginApiResponse>('/login', loginData);
  }

  async refresh(refreshToken: string): Promise<TLoginApiResponse> {
    return await this.post<TLoginApiResponse>('/refresh', { refreshToken });
  }

  async logout(refreshToken: string) {
    return await this.post('/logout', { refreshToken });
  }
}

export default new LoginRepository();
